// src\components\Payroll\ProcessPartialSalaryFld\shared\EmployeeDtrModal.jsx
import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import axios from '../../../../api/apiClient';
import { domain, token } from '../../../Security';
import { CreateTableNew as CreateTable } from "../../../../common/APICommon";
import { LoadingSpinner } from "../../../../common/Loading"; // ADDED

// MODIFIED: accepts batchId instead of effectiveDate — date range is now computed on the backend
// MODIFIED: uses new dedicated GET endpoint — no more full-table loads from SelectLogsDataOnly
export const EmployeeDtrModal = ({ isOpen, onClose, employee, batchId }) => {
  const [dtrData, setDtrData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    if (isOpen && employee?.employeePersonalInformationId && batchId) {
      fetchDtr();
    }
  }, [isOpen, employee, batchId]);

  // MODIFIED: GET to new scoped endpoint — backend computes the 15-day window from EffectiveDate
  const fetchDtr = async () => {
    try {
      setLoading(true);
      setDtrData([]);

      const response = await axios.get(
        `${domain}/api/PartialSalaryBatch/${batchId}/employee-dtr/${employee.employeePersonalInformationId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setDtrData(response.data ?? []);
    } catch (error) {
      console.error("Error fetching DTR:", error);
      setDtrData([]);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  // MODIFIED: added Is Leave and Leave Type columns
  const headers = ["Date", "Time In", "Time Out", "Break Out", "Break In", "Is Rest Day", "Is Leave", "Leave Type"];
  const accessors = ["date", "timeIn", "timeOut", "breakOut", "breakIn", "isRestDay", "isLeave", "leaveType"];

  const formatTime = (val) => {
    if (!val) return "—";
    const dt = new Date(val);
    if (isNaN(dt.getTime())) return "—";

    return dt.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).toLowerCase();
  };

  // MODIFIED: normalize rows — backend returns date as string already, times still need formatting
  const normalizeRow = (d) => ({
    ...d,
    date: d.date ?? "—",
    timeIn: formatTime(d.timeIn),
    timeOut: formatTime(d.timeOut),
    breakIn: formatTime(d.breakIn),
    breakOut: formatTime(d.breakOut),
    isLeave: d.isLeave ? "Yes" : "No",
    isRestDay: d.isRestDay ? "Yes" : "No",
    leaveType: d.leaveType ?? "—",
  });

  return (
    <div className="modal-overlay open">
      <div className="modal" style={{ width: "80%", maxWidth: "900px" }}>
        <div className="popUp-header row">
          <div className="popUp-title">
            <h3 style={{ color: "#668fca" }}>
              DTR Records: {employee?.employeeFullName}
            </h3>
          </div>
          <div className="popUp-close"><CloseIcon onClick={onClose} /></div>
        </div>

        <div className="popUp-body column" style={{ padding: "20px" }}>
          <div className="payroll-table2 container">
            <CreateTable
              tableName="EmployeeDtrTable"
              headers={headers}
              accessors={accessors}
              data={dtrData.map(normalizeRow)}
              actions={[]}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              itemsPerPage={10}
              totalItems={dtrData.length}
              loading={loading}
            />
          </div>
        </div>

        <div className="buttons row" style={{ justifyContent: "end", padding: "20px 40px" }}>
          <button className="cancel row" onClick={onClose}>CLOSE</button>
        </div>
      </div>

      {/* ADDED: LoadingSpinner for DTR fetch — replaces relying solely on table skeleton */}
      <LoadingSpinner loading={loading} />

    </div>
  );
};